module.exports = __webpack_public_path__ + "img/item-2.7fde4a3f.png";